// import wsDialog from './wsDialog'
import loading from './features/loading'
import message from './features/message'
import toast from './features/toast'
// import jlHistory from './history'
import modal from './features/modal'
const components = { 
    loading:{
        type: 'directive',
        value: loading
    },
    message:{
        type: 'directive',
        value: message
    },
    toast:{
        type: 'directive',
        value: toast
    },
    // jlHistory:{
    //     type: 'directive',
    //     value: jlHistory  
    // },
    Modal:{
        type: 'directive',
        value: modal  
    }
};
const install = (Vue, pluginOptions = {}) => {
    Object.keys(components).forEach((key) => {
        Vue.component(key, components[key].value);
        if(components[key].type === 'directive'){
            Vue.use(components[key].value)
        } 
    });
};
export default install;


// WEBPACK FOOTER //
// ./src/components/common-components/index.js